/* ===== Midnight Crew · Prefetch global =====
   Enquanto QUALQUER página da dashboard estiver aberta, baixa em segundo
   plano os dados das outras páginas e grava no localStorage nos MESMOS
   formatos de cache que cada página lê (stale-while-revalidate).
   Resultado: navegar entre páginas renderiza instantâneo do cache
   e revalida ao fundo. */
(function(){
  "use strict";
  var MC_API      = "https://script.google.com/macros/s/AKfycbxVP14V5Z7Adf4xT4WZ3cdlCEtjX5qshZZf3keV7ttLuFudGzvoT7K_iHpIiep9fziu/exec";
  var MC_API_SOCIAL = "https://script.google.com/macros/s/AKfycbx4cDDEvk8YNl8_ObUtTyXL44ASWsO24yYbN4RUmPpSekq3eGhyuZGRQ4ieg8_DBoUq/exec";
  /* implantação nova, única que tem os recursos da página de cliente */
  var MC_API_CLIENTE = "https://script.google.com/macros/s/AKfycbx9aaPhx7x-nEVZqZ42EWcDYidUKODBrnrEmOIPCmMjTSdIw74-b7OHkHLBJg6reSi7/exec";
  var MC_TOKEN = "mc_cc6f126b6aaf46bfa553068c22727813";
  var FRESH_MS   = 3*60000;  // não rebaixa se o cache tem menos de 3 min
  var CYCLE_MS   = 4*60000;  // repete o ciclo a cada 4 min enquanto aberto
  var STEP_MS    = 2500;     // espaçamento entre requests (não sobrecarrega o GAS)

  function call(p, apiUrl){
    return new Promise(function(res,rej){
      var base=apiUrl||MC_API;
      var cb="mc_pf_"+Math.random().toString(36).slice(2);
      var s=document.createElement("script");
      var to=setTimeout(function(){cl();rej(new Error("timeout"));},30000);
      function cl(){clearTimeout(to);try{delete window[cb];}catch(e){}if(s.parentNode)s.parentNode.removeChild(s);}
      window[cb]=function(d){cl();res(d);};
      var qs=Object.keys(p).map(function(k){return encodeURIComponent(k)+"="+encodeURIComponent(p[k]);}).join("&");
      s.src=base+"?key="+encodeURIComponent(MC_TOKEN)+"&callback="+cb+"&"+qs;
      s.onerror=function(){cl();rej(new Error("net"));};
      document.head.appendChild(s);
    });
  }
  function fresh(lsKey){
    try{ var s=JSON.parse(localStorage.getItem(lsKey)); return !!(s&&s.ts&&(Date.now()-s.ts)<FRESH_MS); }catch(e){ return false; }
  }
  function save(lsKey, obj){ try{ localStorage.setItem(lsKey, JSON.stringify(obj)); }catch(e){} }

  /* cada alvo grava no formato que a respectiva página lê */
  var TARGETS=[
    { key:"mc_home_kpis_7d",  req:{resource:"home_kpis",range:"7d"},        wrap:function(d){return {ts:Date.now(), d:d};} },
    { key:"mc_p_orders_30d",  req:{resource:"orders",range:"30d"},          wrap:function(d){return {ts:Date.now(), rows:(d&&d.rows)||[]};} },
    { key:"mc_carts_30d",     req:{resource:"abandoned_carts",range:"30d"}, wrap:function(d){return {ts:Date.now(), d:d};} },
    { key:"mc_customers_v1",  req:{resource:"customers"},                   wrap:function(d){return {ts:Date.now(), rows:(d&&d.rows)||[]};} },
    { key:"mc_vip_hub_v1",    req:{resource:"vip_hub"},                     wrap:function(d){return {ts:Date.now(), d:d};} },
    /* agregados da base p/ a página de detalhe de cliente — é o mais pesado do
       lote, então chegar pronto do cache é o que segura o tempo de abertura */
    { key:"mc_cli_base_v1",   req:{resource:"customer_base"},               wrap:function(d){return {ts:Date.now(), d:d};}, api:MC_API_CLIENTE },
    { key:"mc_products_v1",   req:{resource:"products"},                    wrap:function(d){return {ts:Date.now(), rows:(d&&d.rows)||[]};} },
    /* Social — usa o deployment com as funções do Instagram */
    { key:"mc_ig_account_30", req:{resource:"social_instagram",period:30},  wrap:function(d){return {ts:Date.now(),ttl:30*60000,d:d};},  api:MC_API_SOCIAL },
    { key:"mc_ig_media_v1",   req:{resource:"social_ig_media",limit:50},    wrap:function(d){return {ts:Date.now(),ttl:4*3600000,d:(d&&d.data)||[]};}, api:MC_API_SOCIAL },
    /* Gastos — abre instantâneo do cache em qualquer página da dash */
    { key:"mc_gastos_v1",      req:{resource:"gastos_list"},      wrap:function(d){return {ts:Date.now(), rows:(d&&(d.data||d.rows))||[]};}, api:MC_API_SOCIAL },
    { key:"mc_gastos_cats_v1", req:{resource:"categorias_list"},  wrap:function(d){return {ts:Date.now(), rows:(d&&(d.data||d.rows))||[]};}, api:MC_API_SOCIAL }
  ];

  var idx=0;
  function step(){
    if(document.hidden){ setTimeout(step, 30000); return; } // pausa em aba oculta
    var t=TARGETS[idx%TARGETS.length]; idx++;
    var wait = (idx%TARGETS.length===0) ? CYCLE_MS : STEP_MS;
    if(fresh(t.key)){ setTimeout(step, STEP_MS); return; }
    call(t.req, t.api||null).then(function(d){
      if(d && !d.error) save(t.key, t.wrap(d));
    }).catch(function(){}).then(function(){ setTimeout(step, wait); });
  }
  // começa depois que a página atual terminou de carregar o dela
  if(document.readyState==="complete") setTimeout(step, 6000);
  else window.addEventListener("load", function(){ setTimeout(step, 6000); });
})();
